<template>
    <div class="newsHtmls">
        <div class="title">
            {{ Data.title }}
        </div>
        <div class="time">
            {{ Data.createTime }}
        </div>
        <div v-html="Data.detailUrl"></div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            src: "",
            Data: ""
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.Data = this.$store.state.htmlCont
        })
    }

}
</script>
<style lang="scss">

.newsHtmls {
    width: 80%;
    margin: 0 auto;

    padding: 30px;
    padding-top: 100px;
    box-sizing: border-box;

    .title {
        text-align: center;
        font-size: 30px;
        font-weight: bold;
    }

    .time {
        text-align: right;
        font-size: 14px;
        color: 12px;
        margin-top: 20px;
        margin-bottom: 50px;
    }

    img {
        max-width: 100%;
    }
}

@media screen and (max-width:767px) {
.newsHtmls{
    width: 100%;
}
}
</style>